import React from 'react';
import { GridPageSection } from '../../../shared/components/VerticalSpacing';
import styled from 'styled-components';
import Jumbotron from './Jumbotron/Jumbotron';
import Heading from '../../../shared/components/Heading';
import Paragraph from '../../../shared/components/Paragraph';
import { colors } from '../../../shared/lib/styles';
import { Button } from '@99designs/frontend-components/components/Button';
import { squareOnlineStoreBrief } from '../../../shared/lib/platformUrls';
import { publicImageUrl } from '../../lib/publicImageUrl';
import Image from '../../../shared/components/Image';

const Section = styled.div`
    margin: 2.5rem 0;
`;

const FullWidthSection = styled(Section)`
    position: relative;
    left: 50%;
    right: 50%;
    height: 100%;
    width: 100vw;
    margin-left: -50vw;
    margin-right: -50vw;
    padding-bottom: 3rem;
`;

const BrandsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 2rem;

    > * {
        flex: 1;
        margin: 1rem;
    }
`;

const GradientSection = styled(FullWidthSection)`
    padding: 1rem;
    background: linear-gradient(${colors.white}, ${colors.grey100});
`;

const LeftAlignedCTAWrapper = styled(Paragraph)`
    @media screen and (max-width: 499px) {
        padding: 0;
    }

    @media screen and (max-width: 767px) {
        > * {
            width: 100%;
        }
    }
`;

const MainHeadingWrapper = styled.div`
    max-width: 500px;
`;

function SquareLandingPage() {
    const ctaButton = (
        <Button href={squareOnlineStoreBrief()} variations={['jumbo', 'primary']}>
            {__('Get started')}
        </Button>
    );

    return (
        <>
            <GradientSection>
                <GridPageSection verticalSpacing="gutter">
                    <Jumbotron
                        cta={ctaButton}
                        media={
                            <Image
                                alt={__('Square Online Store')}
                                src={publicImageUrl('square/hero.png')}
                                width={604}
                                height={412}
                            />
                        }
                    >
                        <MainHeadingWrapper>
                            <Heading type="h1" variations={['h1', 'with-divider']}>
                                {__(
                                    'Get your business online fast with Square Online Store Experts'
                                )}
                            </Heading>
                            <Paragraph>
                                {__(
                                    `Does your business need to adapt quickly? We’re here to help. Our curated team of Experts will get your Store online, so you can stay focused on running your business.`
                                )}
                            </Paragraph>
                        </MainHeadingWrapper>
                    </Jumbotron>
                </GridPageSection>
            </GradientSection>

            <GridPageSection verticalSpacing="gutter">
                <Heading
                    style={{ textAlign: 'center', maxWidth: '800px', margin: 'auto' }}
                    type="h1"
                    variations={['h1']}
                >
                    {__(
                        '99designs is the creative platform of choice for 468,000 brands and counting'
                    )}
                </Heading>
            </GridPageSection>

            <GridPageSection>
                <BrandsWrapper>
                    {[
                        'bird-thing',
                        'docker',
                        'draft-kings',
                        'optimizely',
                        'quiznos',
                        'univision',
                    ].map((image) => (
                        <Image
                            key={image}
                            style={{ objectFit: 'contain', maxWidth: 133 }}
                            src={publicImageUrl(`square/${image}.png`)}
                            alt={image}
                            width={133}
                            height={66}
                        />
                    ))}
                </BrandsWrapper>
            </GridPageSection>

            <GridPageSection>
                <Jumbotron
                    media={
                        <Image
                            alt="Zoom"
                            style={{ width: '85%' }}
                            src={publicImageUrl('square/side.png')}
                            width={513}
                            height={790}
                        />
                    }
                >
                    <Heading type="h3" variations={['h3']} style={{ marginBottom: 10 }}>
                        {__('Get matched with Experts')}
                    </Heading>
                    <Paragraph>
                        {__(
                            'We’ll connect you with certified designers who best fit your needs. Compare quotes and pick your favorite to get started!'
                        )}
                    </Paragraph>
                    <Heading type="h3" variations={['h3']} style={{ marginBottom: 10 }}>
                        {__('Bring your Store to life')}
                    </Heading>
                    <Paragraph>
                        {__(
                            `Your Expert will unlock the power of Square Online Store for you while keeping your brand top of mind. Provide feedback throughout the process and only release payment when you're happy.`
                        )}
                    </Paragraph>
                    <Heading type="h3" variations={['h3']} style={{ marginBottom: 10 }}>
                        {__('Start selling online')}
                    </Heading>
                    <Paragraph>
                        {__(
                            'Square Online Store keeps business simple. Our Experts will customize your site so you can easily manage inventory, shipping, local delivery, donations, curbside pickup and more—all in one place.'
                        )}
                    </Paragraph>
                    <Heading type="h3" variations={['h3']} style={{ marginBottom: 10 }}>
                        {__('Already have a website?')}
                    </Heading>
                    <Paragraph>
                        {__(
                            'Our Experts can easily migrate your existing site and help you take advantage of all the advanced eCommerce features available to you exclusively through Square Online Store.'
                        )}
                    </Paragraph>
                    <LeftAlignedCTAWrapper>{ctaButton}</LeftAlignedCTAWrapper>
                </Jumbotron>
            </GridPageSection>
        </>
    );
}

export default SquareLandingPage;
